import * as React from 'react';
import { sortBasedOnList } from '../utils';

export interface ITable1ClassProps {
  data: Table4Data;
}

export interface Table4Data { [key: string]: Table4Row }
interface Table4Row {
  thisYear: number;
  lastYear: number;
  change: number;
}

interface ITable1State {
}

const initialState: ITable1State = {
};

const sortOrder = [
  "Vehicle Miles (Millions)",
  "Fatal Crashes",
  "Fatal Crashes Rate (Per 100 million vehicle miles)",
  "Fatalities",
  "Fatality Rate (Per 100 million vehicle miles)",
  "Serious Injuries",
  "Serious Injury Rate (Per 100 million vehicle miles)",
];


export default class Table4 extends React.Component<ITable1ClassProps, ITable1State> {
  public constructor(props: any) {
    super(props);
    this.state = initialState;
  };

  public render() {
    return (
      <React.Fragment>
        {!this.props.data && (
          <p>Loading....</p>
        )}
        {this.props.data && (
          <table className="ss-table summaryTable1">
            <thead>
              <tr>
                <th className="border-right-bold">
                  <div className="ss-table-header">
                    <span className="header-number">4</span>
                    <span className="header-text">MILEAGE AND RATES</span>
                  </div>
                </th>
                <th>THIS YEAR</th>
                <th>LAST YEAR</th>
                <th>% CHG</th>
              </tr>
            </thead>
            <tbody>
              {sortBasedOnList(this.props.data, sortOrder).map(key =>
                <tr key={key}>
                  <td className="border-right-bold">{key}</td>
                  <td className="numberTotals">{this.props.data[key].thisYear}</td>
                  <td className="numberTotals">{this.props.data[key].lastYear}</td>
                  <td className="numberTotals">{this.props.data[key].change}</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </React.Fragment>
    );
  }
}
